/**
 * Blouse Customization Modal Handler
 * Handles the customization form and adds customized blouse to cart
 */


document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, looking for blouse forms...');
  
  // Find all blouse customization forms
  const forms = document.querySelectorAll('[data-blouse-customization-form]');

  forms.forEach((form, index) => {
    //console.log(`Setting up form ${index}:`, form);
    
    const submitButton = form.querySelector('[data-blouse-submit]');
    console.log(`Submit button for form ${index}:`, submitButton);
    
          if (submitButton) {
        //console.log(`Adding click listener to button in form ${index}`);
        submitButton.addEventListener('click', function(e) {
          console.log('Button clicked!');
          handleSubmit(e, form);
        });
      } else {
        console.log(`No submit button found in form ${index}`);
      }
    
    // Also prevent form submission if it somehow gets submitted
    form.addEventListener('submit', function(e) {
      console.log('Form submit prevented');
      e.preventDefault();
      return false;
    });
    
    // Handle radio button styling
    const radioOptions = form.querySelectorAll('.radio-option input[type="radio"]');
    console.log(`Radio options in form ${index}:`, radioOptions.length);
    radioOptions.forEach(radio => {
      radio.addEventListener('change', handleRadioChange.bind(form));
    });
  });
  
  // Fallback: also try to set up after a short delay in case the form is added dynamically
  setTimeout(function() {
    console.log('Fallback: checking for forms again...');
    const formsFallback = document.querySelectorAll('[data-blouse-customization-form]');
    //console.log('Fallback found forms:', formsFallback.length);
    
    formsFallback.forEach((form, index) => {
      const submitButton = form.querySelector('[data-blouse-submit]');
      if (submitButton && !submitButton.hasAttribute('data-listener-added')) {
       // console.log(`Adding fallback click listener to button in form ${index}`);
        submitButton.setAttribute('data-listener-added', 'true');
        submitButton.addEventListener('click', function(e) {
          console.log('Fallback button clicked!');
          handleSubmit(e, form);
        });
      }
    });
  }, 1000);
  
  // Event delegation approach - listen for clicks on the document
  document.addEventListener('click', function(e) {
          if (e.target.matches('[data-blouse-submit]')) {
        const form = e.target.closest('[data-blouse-customization-form]');
        if (form) {
          handleSubmit(e, form);
        }
      }
  });
  
  // Watch for dynamically added content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.matches && node.matches('[data-blouse-customization-form]')) {
            setupForm(node);
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function setupForm(form) {
  
  const submitButton = form.querySelector('[data-blouse-submit]');
  if (submitButton && !submitButton.hasAttribute('data-listener-added')) {
    submitButton.setAttribute('data-listener-added', 'true');
            submitButton.addEventListener('click', function(e) {
          console.log('New form button clicked!');
          handleSubmit(e, form);
        });
  }
  
  // Handle radio button styling
  const radioOptions = form.querySelectorAll('.radio-option input[type="radio"]');
  radioOptions.forEach(radio => {
    radio.addEventListener('change', handleRadioChange.bind(form));
  });
}

function handleRadioChange(event) {
  const radioOption = event.target.closest('.radio-option');
  const radioGroup = radioOption.closest('.radio-group');
  
  // Remove active class from all options in the group
  radioGroup.querySelectorAll('.radio-option').forEach(option => {
    option.classList.remove('active');
  });
  
  // Add active class to selected option
  if (event.target.checked) {
    radioOption.classList.add('active');
  }
}

async function handleSubmit(event, form) {
  event.preventDefault();
  if (!form) {
    console.error('No form provided to handleSubmit');
    return;
  }

  // Get form data
  const formData = new FormData(form);
  const customizationData = {};
  
  // Convert FormData to object
  for (const [key, value] of formData.entries()) {
    if (key !== 'product_id' && key !== 'variant_id' && key !== 'quantity') {
      customizationData[key] = value;
    }
  }

  // Show loading state
  setLoadingState(form, true);

  try {
    // Add customized blouse to cart
    await addCustomizedBlouseToCart(formData, customizationData);
    // Refresh cart
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.querySelector('[aria-controls="cart-drawer"]').click();
    // Close modal
    closeModal(form);
    
    // Show success message
    //showSuccessMessage();
  
    
    
    
  } catch (error) {
    console.error('Failed to add customized blouse to cart:', error);
    showErrorMessage(error.message);
  } finally {
    setLoadingState(form, false);
  }
}

async function addCustomizedBlouseToCart(formData, customizationData) {
  const variantId = formData.get('variant_id');
  const quantity = formData.get('quantity');

  // Create cart add request
  const cartData = {
    items: [{
      id: parseInt(variantId),
      quantity: parseInt(quantity),
      properties: {
        '_customized_blouse': 'Yes',
        'Collar Design': customizationData.neck_style,
        'Back Style': customizationData.back_style,
        'Sleeve Type': customizationData.sleeve_type,
        'Cut Style': customizationData.cut_style,
        'Opening': customizationData.opening,
        'Padding': customizationData.padding,
        'Piping': customizationData.piping,
        'Size': customizationData.size
      }
    }]
  };

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(cartData)
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.description || 'Failed to add customized blouse to cart');
  }

  return response.json();
}

function setLoadingState(form, isLoading) {
  const submitButton = form.querySelector('[data-blouse-submit]');
  if (submitButton) {
    if (isLoading) {
      submitButton.textContent = 'Adding to Cart...';
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    } else {
      submitButton.textContent = 'Add Customized Blouse to Cart';
      submitButton.disabled = false;
      submitButton.classList.remove('loading');
    }
  }
}

function closeModal(form) {
  // Find and close the modal
  const modal = form.closest('.modal');
  if (modal) {
    const closeEvent = new CustomEvent('modal:close', { bubbles: true });
    modal.dispatchEvent(closeEvent);
  }
}

function showErrorMessage(message) {
  // Create error banner
  const banner = document.createElement('div');
  banner.className = 'banner banner--error';
  banner.setAttribute('role', 'alert');
  banner.innerHTML = `
    <div class="banner__content">
      <p>Error: ${message}</p>
    </div>
  `;

  // Add banner to page
  document.body.appendChild(banner);

  // Remove banner after 5 seconds
  setTimeout(() => {
    if (banner.parentNode) {
      banner.remove();
    }
  }, 5000);
}
